import React, { useEffect, useState } from "react"; 
import { useTranslation } from "../../../contexts/TranslationProvider"; 
import { toast } from "react-toastify"; 
import "./userByTypeLevel.scss"; 
import useApiClientWithLoading from "../../../services/api/ApiClient"; 
import { TypeLevel1Client } from "../../../services/api/TypeLevel1Client"; 
import Loading from "../../common/Loading"; 

interface UsersByTypelevelProps {
  onClose: () => void;
  levelId?: number;
  title?:string;
}

function UsersByTypelevel({ onClose, levelId,title }: UsersByTypelevelProps) {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<any[]>([]); 
  const [email, setEmail] = useState(""); 
  const apiClient = useApiClientWithLoading();
  const type1Client = new TypeLevel1Client(apiClient);

  useEffect(() => {
    setLoading(true);
    const fetchUsers = async () => {
      try {
        const response = await type1Client.users(levelId); 
        setUsers(response.rows);
      } catch (e) {
        toast.error("Failed to load users.");
      } finally {
        setLoading(false);
      }
    };

    if (levelId) {
      fetchUsers();
    }
  }, [levelId]);

  const { t, language } = useTranslation();

  async function handleRemoveUser(userId: string) {
    try {
      const response = await type1Client.removeTypeLevelUserAssociation(levelId, userId);
      toast.success("User removed successfully.");
      const updatedUsers = await type1Client.users(levelId);
        setUsers(updatedUsers.rows);
    } catch (e) {
      console.log(e);
      toast.error("Failed to remove user.");
    }
  }

  async function handleAddUserByEmail() {
    if (!email) {
      toast.error("Please enter an email.");
      return;
    }
  
    try {
      const result = await type1Client.assignTypeLevelToUser(levelId, email);
      if (result.success) {
        toast.success(result.message);
        setEmail("");
        const updatedUsers = await type1Client.users(levelId);
        setUsers(updatedUsers.rows);
      } else {
        toast.error(result.message);
      }
    } catch (e) {
      toast.error("Failed to add user.");
      console.log(e);
    }
  }
  
  return (
    <>
      <div className="modal-backdrop"></div>
      <div id="type-add-popup" className="type-add-popup">
        <div className="modal modal-add-type d-flex justify-content-center align-items-center">
          <div>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                  aria-label="Close"
                  style={{ marginRight: language === "ar" && "75%" }}
                ></button>
              </div>
              {loading ? (
                <Loading height="50vh" />
              ) : (
                <div className="modal-body body-add-type" style={{ maxWidth: "700px",padding:"2rem" }}>
                    <div className="add-user-form">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email to add"
                      className="email-input"
                    />
                    <button onClick={handleAddUserByEmail} className="submit-btn">
                      Add 
                    </button>
                  </div>
                  <div className="user-list">
                    {users.map((user) => (
                      <div key={user.id} className="user-badge">
                        <span className="badge-email">{user.email}</span>
                        <button
                          className="remove-btn"
                          onClick={() => handleRemoveUser(user.id)}
                        >
                          X
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UsersByTypelevel;
